import {restorePasswordByEmail} from "../service/restore-password-email-state/restore-password-email-state";
import {createSlice, PayloadAction, SliceCaseReducers} from "@reduxjs/toolkit";


interface ResetPasswordState {
    status: 'idle' | 'pending' | 'fulfilled' | 'rejected';
    errors: Record<string, string>;
    email: string;
    loading: boolean;
    message:{
        text:string,
        title:string
    }
}

const initialState: ResetPasswordState = {
    status: 'idle',
    email: "",
    loading: false,
    errors: {},
    message:{
        text:'',
        title:''
    }
};



const resetPasswordEmailSlice = createSlice<ResetPasswordState, SliceCaseReducers<ResetPasswordState>>({
    name: "resetPasswordEmail",
    initialState,
    reducers: {
        resetState: (state) => {
            state.loading = false;
        },
        setEmail: (state, action: PayloadAction<string>) => {
            state.email = action.payload;
        },
        setResetPasswordData: (state, action: PayloadAction<Partial<ResetPasswordState>>) => {
            Object.assign(state, action.payload);
        },
    },
    extraReducers: (builder) => {
        builder.addCase(restorePasswordByEmail.pending, (state) => {
            state.status = 'pending';
            state.loading = true;

        });
        builder.addCase(
            restorePasswordByEmail.fulfilled,
            (state, action: PayloadAction<{ success: boolean; status: string }>) => {
                if (action.payload.success) {
                    state.status = 'fulfilled';
                }
                state.loading = false;
            }
        );
        builder.addCase(restorePasswordByEmail.rejected, (state,action) => {
            state.status = 'rejected';
            state.loading = false;
            if (action.payload) {
                state.errors = {...state.errors, ...action.payload};
            }
        });
    },
});


export const { resetState, setEmail,setResetPasswordData } = resetPasswordEmailSlice.actions;

export const { reducer: resetPasswordEmailReducer } = resetPasswordEmailSlice;